import { render, staticRenderFns } from "./field_edit.vue?vue&type=template&id=4140d124&scoped=true"
import script from "./field_edit.vue?vue&type=script&lang=js"
export * from "./field_edit.vue?vue&type=script&lang=js"
import style0 from "./field_edit.vue?vue&type=style&index=0&id=4140d124&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4140d124",
  null
  
)

export default component.exports